import constant_label from '../../constants';
import '../../../src/DialSightStyles.css'
 const DefaultButton=({children,onClick,style})=> {
  return  <button  type="button" className='default_button' onClick={onClick} style={style}>
        {children}
      </button>
 
}
export default DefaultButton;
